var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var d3 = {
  ...require("d3-fetch/dist/d3-fetch.min"),
  ...require("d3-selection/dist/d3-selection.min"),
};

var {
  cityLookup
} = require("./lib/helpers");

var renderPrices = require("./renderPrices");

let pymChild;
let selectedCity, selectedCategory;

var onWindowLoaded = function () {
  render();

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
};

var render = function () {
  let updatePrices = function (selectedCity, selectedCategory, categoryData) {
    var container = "#prices";
    var element = document.querySelector(container);
    var width = element.offsetWidth;
    renderPrices({
      container,
      width,
      selectedCity,
      selectedCategory,
      categoryData,
    });

    if (pymChild) {
      pymChild.sendHeight();
    }
  };

  loadCSV().then(data => {
    const grocery_data = processData(data);
    var containerElement = d3.select(".graphic");
    containerElement.html("");

    var selector_wrapper = containerElement.append("div").attr("class", "selector-wrapper")

    selector_wrapper.append("span").attr("class","selector-header").text("Choose a metro area and a category")

   const selector_container = selector_wrapper
    .append("div")
    .attr("class", "selectors-container")

    var city_selector = selector_container
      .append("select")
      .attr("class", "selector")
      .attr("id", "city-selector");

    city_selector
      .selectAll("option")
      .data(Object.keys(grocery_data).sort())
      .enter()
      .append("option")
      .attr("value", d => d)
      .text(d => d);

    if (typeof selectedCity == "undefined") {
      city_selector.property("value", "Pittsburgh");
    }

    var category_selector = selector_container
      .append("select")
      .attr("class", "selector")
      .attr("id", "category-selector");

    category_selector
      .selectAll("option")
      .data(Object.keys(grocery_data[city_selector.property("value")]["categories"]).sort())
      .enter()
      .append("option")
      .attr("value", d => d)
      .text(d => d);

    if (typeof selectedCategory == "undefined") {
      category_selector.property("value", "Dairy & Eggs");
    }

    var updateChoices = function () {
      selectedCity = d3.select("#city-selector").property("value");
      selectedCategory = d3.select("#category-selector").property("value");

      updatePrices(
        selectedCity,
        selectedCategory,
        grocery_data[selectedCity]["categories"][selectedCategory]
      );
    };

    d3.select("#city-selector").on("change", function () {
      updateChoices();
    });

    d3.select("#category-selector").on("change", function () {
      updateChoices();
    });

    containerElement.append("div").attr("id", "prices");

    updateChoices();
  });
};

async function loadCSV() {
  try {
    const data = await d3.csv("grocery_data.csv");
    return data;
  } catch (error) {
    console.error("Error loading the CSV file", error);
  }
}

var processData = function (data) {
  let temp_data = {};

  data.forEach(row => {
    let swing_state, category, subcategory, city, y23, y24, pct_chg;
    ({ swing_state, category, subcategory, city, y23, y24, pct_chg } = row);

    city = city.trim();

    if (city in cityLookup) {
      city = cityLookup[city]
    }

    if (category == "Dairy") {
      category = "Dairy & Eggs"
    }

    if (!temp_data[city]) {
      temp_data[city] = {
        swing_state: swing_state,
        categories: { [category]: {} },
      };
    }
    if (!temp_data[city]["categories"][category]) {
      temp_data[city]["categories"][category] = {};
    }
    temp_data[city]["categories"][category][subcategory] = {
      y23: y23,
      y24: y24,
      pct_chg: pct_chg,
    };
  });

  return temp_data;
};

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);
